<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Query</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Query</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="Query">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{ name: 'QueryList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div class="form-group">
                    <label class="control-label">Query</label>
                    <textarea
                      id="body"
                      name="body"
                      v-model="value.body"
                      class="form-control body"
                      placeholder="Query"
                      rows="3"
                      :readonly="is_edit"
                    ></textarea>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Reply</label>
                    <textarea
                      id="reply"
                      name="reply"
                      v-model="value.reply"
                      class="form-control reply"
                      placeholder="Reply"
                      rows="3"
                    ></textarea>
                  </div>

                  <div class="form-group">
                    <label class="control-label">Department</label>
                    <input
                      type="text"
                      id="department"
                      name="department"
                      v-model="value.department"
                      class="form-control department"
                      placeholder="Department"
                    />
                  </div>
                  <div class="form-group">
                    <div class="custom-control custom-checkbox">
                      <input
                        class="custom-control-input"
                        v-bind:class="{
                          'has-error': errors.has('is_approved'),
                        }"
                        type="checkbox"
                        :id="'is_approved'"
                        name="is_approved"
                        v-model="value.is_approved"
                      />
                      <label :for="'is_approved'" class="custom-control-label"
                        >Is approved?</label
                      >
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Course</label>
                    <multiselect
                      id="queryable_id"
                      name="queryable_id"
                      :options="Object.keys(pre.queryable_id)"
                      :custom-label="(opt) => pre.queryable_id[opt]"
                      v-bind:class="{ 'has-error': errors.has('queryable_id') }"
                      v-validate="'required'"
                      v-model="value.queryable_id"
                      class="queryable_id"
                      placeholder="Select Queryable Id"
                      :searchable="true"
                      :close-on-select="true"
                      :show-labels="false"
                    ></multiselect>
                    <div
                      class="help text-danger"
                      v-show="errors.has('queryable_id')"
                    >
                      {{ errors.first("queryable_id") }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { DepartmentsAPI, CommonAPI } from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";

export default {
  name: "QueryForm",
  metaInfo: {
    title: "Query | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},

    value: {},
    pre: {
      queryable_id: {},
    },
  }),
  methods: {
    queryableIdOptions: function () {
      return new Promise((resolve, reject) => {
        axios
          .get("/get-dropdown-options/8")
          .then((response) => {
            resolve(response.data);
            //return response.data;
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },

    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/queries";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/queries/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "QueryList" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/queries/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log("error " + error);
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;
      await this.queryableIdOptions().then((queryable_id) => {
        this.pre.queryable_id = queryable_id;
      });

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((error) => {
            console.log(error.response);
          });
      }

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /*created() {
    this.$emit("update:layout", MasterLayout);
  },*/
};
</script>
